var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dots)?_c('i',{staticClass:"icon-dot-3 op-btn",attrs:{"title":_vm.title},on:{"click":function($event){return _vm.$emit('click', $event)}}}):_c('span',{staticClass:"op-btn"},[_c('span',{staticClass:"caret"})])}
var staticRenderFns = []

export { render, staticRenderFns }